export default __webpack_public_path__ + "static/media/KN.efa5d9e3.svg";